import React, {Component} from "react";
import "./intro.scss";

function Bienvenida (){
	return (<>
	<p>Bienvenido/a al Curso de ecografía musculosquelética online basado en la tecnología de Entornos de Capacitación de VINNO Ultrasound S.L.U.</p>
	<p>En esta sección te vamos a explicar los puntos principales que regirán el desarrollo del curso:</p>
	<ul>
		<li>Existe una parte teórica previa para para posteriormente pasar a la práctica. Es necesario y obligatorio pasar por esa fase, de otro modo no se podrá continuar avanzando en el curso. Los contenidos teóricos permiten ser descargados en formato vídeo (mp4) para poder visionarlos cuantas veces quiera.</li>
		<li>La parte práctica consta de un modelo de exploración con descripción en cada fase del posicionamiento del paciente y explorador, abriéndose la posibilidad de mover la sonda por la superficie del modelo hasta encontrar la zona diana. Para saber si estamos en la región correcta veremos un “indicador” (en la parte superior izquierda) que cambiará de color según nos acerquemos al objetivo, poniéndose de color verde cuando estamos en el lugar correcto y apareciendo la imagen ecográfica.</li>
		<li>Al final del curso habrá un examen práctico donde se tendrán que hacer exploraciones mediante el generador de examen aleatorio.</li>
		<li>Para el desarrollo de este curso recomendamos usar los navegadores Chorme o Firefox actualizados y un monitor con una resolución de pantalla FullHD (1920 x 1080) o superior. También, para mayor precisión y comodidad, recomendamos el uso de ratón.</li>
		<li>Le recordamos que tiene a tu disposición un tutor online para resolver cualquier duda sobre la formación y que le dará respuesta en un tiempo inferior a 48 h.</li>
	</ul>
	<p>Gracias.</p>
	</>);
}

function Tutor (){
	return <div className="tutor">
		<p>PUEDE CONTACTAR CON EL TUTOR DEL CURSO VÍA CORREO ELECTRÓNICO:</p>
		<a href="mailto:info@vinnospain.com">info@vinnospain.com</a>
	</div>;
}

function Bibliografia (){
	return <div className="bibliografia">
		<h1>Bibliografía</h1>
		<ol>
			<li>Balius, R. <b>Ecografía musculoesquelética : sistemática de exploración, bloqueos nerviosos periféricos.</b> (Editorial Paidotribo, 2007).</li>
			<li>Bianchi, S., Martinoli, C. & Derchi, L. E. <b>Ecografía musculoesquelética.</b> (Marbán, 2014).</li>
			<li>McNally, E. G. <b>Ultrasonografía musculoesquelética.</b> (Marban, 2006).</li>
			<li>Van Holsbeeck, M. T., Introcaso, J. H. & Alonso López, J. A. <b>Ecografía musculoesquelética.</b> (Marban, 2002).</li>
			<li>Martínez Paya, J. J. <b>Anatomía ecográfica del hombro : herramienta de prevención, diagnóstico, investigación y validación de técnicas terapéuticas.</b> (Editorial Médica Panamericana, 2008).</li>
			<li>Ahuja, A. T. <b>Imagen anatómica. Ecografía.</b> (Marbán, 2012).</li>
			<li>Ventra Ríos, L. <b>Manual de ecografía musculoesquelética.</b> (Editorial Médica Panamericana, 2010).</li>
			<li>Bueno Horcajadas, A. & Cura Rodríguez, J. L. del. <b>Ecografía musculoesquelética esencial.</b> (Editorial Médica Panamericana, 2011).</li>
			<li>Sans, N., Lapègue, F., Brasseur, J.-L. & Fumat, C. <b>Ecografía musculoesquelética.</b></li>
			<li>Jacobson, J. A. <b>Ecografia musculoesqueletica.</b> (Ediciones Journal, 2010).</li>

		</ol>
	</div>;
}

class Intro extends Component {
	state = {
		pagina:"intro",
	}
	paginas= [
		{
			id:"intro",
			label:"Bienvenida",
			component:<Bienvenida/>,
		},
		{
			id:"tutor",
			label:"Tutor",
			component:<Tutor/>,
		},
		{
			id:"biblio",
			label:"Bibliografía",
			component:<Bibliografia/>,
		},
	]
	cargapagina = (pagina) => {this.setState({pagina:pagina});}
	render(){
		let component = null;
		let botonera = this.paginas.map((item)=>{
			let clase = "boton";
			if(this.state.pagina === item.id){
				clase += " on";
				component = item.component;
			}
			return <div key={item.id} className={clase} onClick={()=>this.cargapagina(item.id)}>{item.label}</div>;
		});
		return <div className="intro"><div className="botoneraIntro">{botonera}</div>{component}</div>;
	}
}

export default Intro;